import { Outlet, useLocation, Navigate } from "react-router-dom";
import SettingsSidebar from "@/settings/components/settings-sidebar/settings-sidebar";
import { SETTINGS_URL } from "@/settings/config/settings-urls";

const SettingsLayout = () => {
  const location = useLocation();

  // Redirect to organization settings if on root settings path
  if (location.pathname === SETTINGS_URL.ROOT || location.pathname === `${SETTINGS_URL.ROOT}/`) {
    return <Navigate to={SETTINGS_URL.ORGANIZATION} replace />;
  }

  return (
    <div className="flex h-full w-full">
      <SettingsSidebar />
      <main className="flex-1 overflow-y-auto bg-background">
        <Outlet />
      </main>
    </div>
  );
};

export default SettingsLayout;
